import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  Input,
  InputProps
} from '@chakra-ui/react'
import { AsYouType, isValidNumber } from 'libphonenumber-js'
import { Controller, FieldValues, useFormContext } from 'react-hook-form'
import { AttentionIcon } from '../Icons/AttentionIcon'
import { CommonFormLabel } from './CommonFormLabel'
import { FieldInputProps, getErrorMessage } from './FormTextInput'

type FormTextInputProps<T extends FieldValues> = FieldInputProps<T, string> &
  InputProps

export const FormPhoneNumberInput = <T extends FieldValues = never>({
  name,
  isRequired,
  label,
  labelIndexNumber,
  helperText,
  helpTooltipText,
  showErrorText = true,
  errorMessage,
  formControlWidth,
  w,
  ...inputProps
}: FormTextInputProps<T>): ReturnType<React.VFC> => {
  const { control } = useFormContext()

  const _errorMessage = getErrorMessage(name) || errorMessage
  return (
    <FormControl
      isRequired={isRequired}
      isInvalid={_errorMessage}
      w={formControlWidth || 'auto'}
    >
      <CommonFormLabel
        label={label}
        labelIndexNumber={labelIndexNumber}
        helpTooltipText={helpTooltipText}
        isRequired={isRequired}
      />

      <Controller
        render={({ field: { onChange, onBlur, value } }) => {
          return (
            <Input
              {...inputProps}
              w={w}
              onChange={onChange}
              value={value as string}
              onBlur={(e) => {
                //入力した内容がバリデーションに引っかかったときはエラー
                if (
                  !(
                    /^[0０]/.test(e.target.value) &&
                    isValidNumber(e.target.value, 'JP')
                  )
                ) {
                  onChange(e.target.value)
                  onBlur()
                  return
                }
                onChange(new AsYouType('JP').input(e.target.value))
                onBlur()
              }}
            />
          )
        }}
        control={control}
        name={name}
      />

      {showErrorText && (
        <FormErrorMessage>
          <AttentionIcon />
          {_errorMessage}
        </FormErrorMessage>
      )}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
}
